import { HttpInterceptorFn } from '@angular/common/http';

import { resolveBackendUrl, shouldIncludeCredentialsForUrl } from './backend-urls';

export const backendUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const resolvedUrl = resolveBackendUrl(req.url);
  if (resolvedUrl === req.url && !shouldIncludeCredentialsForUrl(req.url)) return next(req);

  return next(
    req.clone({
      url: resolvedUrl,
      withCredentials: req.withCredentials || shouldIncludeCredentialsForUrl(req.url),
    }),
  );
};
